import { useMemo } from 'react';
import { useI18n } from '@namespace/i18n';
import {
  MOBILE_MONEY_KYIVSTAR_SERVICE_ID,
  useGetUsedSIDList
} from '@namespace/payments-sw';

export const useUsedSIDList = () => {
  const { t } = useI18n();
  const list = useGetUsedSIDList();

  return useMemo(
    () => list.filter(notKyivstar).map(createService(t)),
    [list, t]
  );
};

const notKyivstar = (serviceId) =>
  serviceId !== MOBILE_MONEY_KYIVSTAR_SERVICE_ID;

const createService = (t) => (serviceId) => ({
  value: String(serviceId),
  label: t(`personalOffice.filter.options.depositHistory.wallet.${serviceId}`)
});
